const analytics = () => ({
  parentNav: 'analytics',
  routes: ['analytics'],
  menuItems: [],
});

export default analytics;
